<script>
    export default {
        name: 'user-wizard-header',
        props: {
            text: String,
            success: Boolean,
            error: Boolean
        },
        computed: {
            classText() {
                if (this.error) return 'pa-2 text-center text-danger';
                if (this.success) return 'pa-2 text-center text-success';
                return 'pa-2 text-center';
            }
        }
    }
</script>

<template>
    <div style="font-size: 1.15rem" :class="classText">
        {{text}}
    </div>
</template>
